export default __webpack_public_path__ + "images/a315bda5af408975478c1a0def56adf1.png";